import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Nav, NavItem, NavLink } from 'reactstrap'
import classNames from 'classnames'
import PageHeader from '../../common/PageHeader'
import RewardsReport from './report/RewardsReport'
import RewardsConfig from './config/RewardsConfig'
import RewardsPartners from './partners/RewardsPartners'

const TABS = [
  { id: 'report', label: 'Reporte financiero', component: RewardsReport },
  { id: 'config', label: 'Configuración', component: RewardsConfig },
  { id: 'partners', label: 'Aliados', component: RewardsPartners }
]

// HO-TASK-289: panel de control del programa para root. La pestaña va en la
// URL (?tab=) para poder compartir el enlace directo al reporte o a la
// configuración.
const RootRewards = () => {
  const history = useHistory()
  const { pathname, search } = useLocation()
  const requested = new URLSearchParams(search).get('tab')
  const active = TABS.find((tab) => tab.id === requested) || TABS[0]
  const ActiveTab = active.component

  const selectTab = (id) => history.replace(`${pathname}?tab=${id}`)

  return (
    <>
      <PageHeader
        title="Homelan Rewards"
        titleTag="h2"
        description="Costo, margen y cobertura del programa; parámetros de la economía y aliados de los aceleradores."
        className="mb-3"
        col={{ lg: 9 }}
      />
      <Nav tabs className="mb-3 flex-nowrap overflow-auto" role="tablist">
        {TABS.map((tab) => (
          <NavItem key={tab.id}>
            <NavLink
              tag="button"
              type="button"
              role="tab"
              aria-selected={tab.id === active.id}
              className={classNames('text-nowrap bg-transparent', { active: tab.id === active.id })}
              onClick={() => selectTab(tab.id)}
            >
              {tab.label}
            </NavLink>
          </NavItem>
        ))}
      </Nav>
      <ActiveTab />
    </>
  )
}

export default RootRewards
